import React, { useEffect, useCallback, useState } from 'react'
import { Layout, Button, Modal, Checkbox, Input, Tabs } from 'antd'
import { PlusSquareOutlined } from '@ant-design/icons'
import { useNavigate } from 'react-router-dom'
import { draftWatermarksAction } from '../../../actions/watermark'
import sensors from '../../../utils/sensors'
import './index.scss'

import Published from './Published'
import Unpublished from './Unpublished'
import { useAppDispatch, useAppSelector } from '../../../app/hooks'
import { TEMPLATES } from '../../../constants/watermark'

import PageHeader from '@/components/PageHeader'
import AntdProvider from '@/components/AntdProvider'
const { Content } = Layout
const { Search } = Input
const TabPane = Tabs.TabPane

interface SearchWatermarkProps {
  onSearch: (value: string) => void
}

const SearchWatermark: React.FC<SearchWatermarkProps> = ({ onSearch }) => {
  return (
    <Search
      style={{ marginRight: '10px' }}
      placeholder="水印搜索"
      onSearch={onSearch}
    />
  )
}

const WatermarkList = () => {
  const [keyword, setKeyword] = useState<string>('')
  const [newModalVisible, setNewModalVisible] = useState<boolean>(false)
  const [baseID, setBaseID] = useState<string>('')
  const groupID = useAppSelector((state) => state.group.groupId)
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const watermarkList = useAppSelector((state) => state.watermark.watermarkList)
  const draftWatermarkList = useAppSelector(
    (state) => state.watermark.draftWatermarkList
  )

  const fetchWatermarks = useCallback(() => {
    dispatch(draftWatermarksAction(groupID))
  }, [groupID])

  useEffect(() => {
    fetchWatermarks()
  }, [])

  return (
    <Layout className="WatermarkList">
      <PageHeader
        className="Header"
        ghost={true}
        title="团队水印管理"
        extra={
          <Button
            type="primary"
            onClick={() => {
              sensors.track('web_workgroup_watermark_manage_page_click', {
                clickItem: 'addModel'
              })
              setNewModalVisible(true)
            }}
          >
            <PlusSquareOutlined />
            添加模板
          </Button>
        }
      />
      <Content className="content" id="watermark-list">
        <Tabs
          size="large"
          tabBarStyle={{ background: '#fafafa', paddingRight: '10px' }}
          tabBarExtraContent={
            <SearchWatermark onSearch={(value) => setKeyword(value)} />
          }
        >
          <TabPane tab={`已发布（${watermarkList.length}）`} key="1">
            <Published keyword={keyword} />
          </TabPane>
          {draftWatermarkList.length > 0 && (
            <TabPane tab={`未发布（${draftWatermarkList.length}）`} key="2">
              <Unpublished keyword={keyword} />
            </TabPane>
          )}
        </Tabs>
        <Modal
          getContainer={false}
          title="选择水印类型"
          width={600}
          open={newModalVisible}
          onCancel={() => {
            setNewModalVisible(false)
            setBaseID('')
          }}
          onOk={() => {
            navigate('/watermark/editor?action=new&base_id=' + baseID)
          }}
        >
          <div className="templates-wrapper">
            {TEMPLATES.map((template, index) => (
              <div className="template" key={index}>
                <img src={template.cover} alt="" />
                <Checkbox
                  checked={template.id === baseID}
                  onChange={(e) =>
                    setBaseID(e.target.checked ? template.id : '')
                  }
                />
              </div>
            ))}
          </div>
        </Modal>
      </Content>
    </Layout>
  )
}

const WatermarkListPage = () => (
  <AntdProvider>
    <WatermarkList />
  </AntdProvider>
)

export default WatermarkListPage
